const QUICK_LINKS = [
  { label: '今日热榜', href: '#trending' },
  { label: '热门话题', href: '#topics' },
  { label: '观点对撞', href: '#comments' },
  { label: '讨论版块', href: '#channels' },
  { label: '常见问题', href: '#faq' },
];

const TOPIC_LINKS = ['影视考古', '综艺现场', '消费观察', '直播回放', '音乐现场', '细节研究所'];

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-base" />
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">黑料社网</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              黑料社网社区，和吃瓜群众一起把话题聊到细节里。看爆料、读评论、发观点，在互动中挖掘更多隐藏细节。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {['ri-weibo-line', 'ri-wechat-line', 'ri-mail-line', 'ri-rss-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  <i className={`${icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-medium tracking-widest text-foreground-500">快速导航</p>
            <ul className="mt-4 flex flex-col gap-2.5">
              {QUICK_LINKS.map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="cursor-pointer text-sm text-foreground-700 hover:text-primary-700">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs font-medium tracking-widest text-foreground-500">热门版块</p>
            <div className="mt-4 flex flex-wrap gap-2">
              {TOPIC_LINKS.map((tag) => (
                <a
                  key={tag}
                  href="#channels"
                  className="cursor-pointer whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-3 py-1 text-xs text-foreground-700 transition-colors hover:border-secondary-300 hover:text-secondary-800"
                >
                  {tag}
                </a>
              ))}
            </div>
            <p className="mt-5 text-xs leading-relaxed text-foreground-500">
              社区内容均为用户观点交流，不代表本站立场。请理性讨论，尊重不同声音。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">© 2026 黑料社网 · 社区互动讨论平台</p>
          <div className="flex flex-wrap items-center gap-4">
            <span className="cursor-pointer text-xs text-foreground-600 hover:text-foreground-900">社区规范</span>
            <span className="cursor-pointer text-xs text-foreground-600 hover:text-foreground-900">内容声明</span>
            <span className="cursor-pointer text-xs text-foreground-600 hover:text-foreground-900">联系反馈</span>
          </div>
        </div>
      </div>
    </footer>
  );
}